// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  url: 'https://hvac-api.vl1.in/api/',
  // url: 'http://128.199.25.224/invoice-app-server/public/api/',
  // url: "http://127.0.0.1:8000/api/",
  frontend_url: 'https://hvac.vl1.in',
  // frontend_url: "http://128.199.25.224/invoiceapppwa/display/",
  // frontend_url: "http://localhost:4200/",
};



/*
 * For easier debugging in development mode, you can import the following file

 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/dist/zone-error';  // Included with Angular CLI.
// ng build --base-href="https://app.invoicehood.com/" --deploy-url="https://app.invoicehood.com/"
// ng build --base-href="http://128.199.25.224/invoiceapppwa/display/" --deploy-url="http://128.199.25.224/invoiceapppwa/display/"
